import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { BuildingTypes } from '@app/shared/models/building-types';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BuildingTypesService extends ApiService {
  private allBuildingTypes$?: Observable<BuildingTypes[]>;
  constructor(public http: HttpClient) {
    super(http);
  }

  public getById(guid: string): Observable<BuildingTypes[]> {
    return this.http.get<BuildingTypes[]>(this.endpoint(`socrates/meters/api/references/BuildingTypes?$filter=guid eq ${guid}`));
  }

  public getAll(): Observable<BuildingTypes[]> {
    if (!this.allBuildingTypes$) {
      this.allBuildingTypes$ = this.http
        .get<BuildingTypes[]>(this.endpoint(`socrates/meters/api/references`, `BuildingTypes?$filter=isActive eq true`))
        .pipe(shareReplay({ bufferSize: 1, refCount: true }));
    }
    return this.allBuildingTypes$;
  }
}
